import React, { Context } from 'react';
import { AppContext, AppContextInterface } from '../app-context-provider';
import { FileItem } from '../components/component-switcher';
import {
  backgroundStyle,
  ColorType,
  rounded,
  shadow,
} from '../helpers/style-helpers';
import Img from './Img';
import { ImZoomIn } from 'react-icons/im';
import './Lightbox.css';

export interface FileComponentState {}
class FileComponent extends React.Component<FileItem, FileComponentState> {
  static contextType: Context<AppContextInterface | null> = AppContext;
  static context: AppContextInterface;
  state: FileComponentState = {};

  constructor(props: FileItem) {
    super(props);
    this.downloadFile = this.downloadFile.bind(this);
  }

  public downloadFile(event: React.MouseEvent<HTMLElement>): void {
    console.log(event);
  }

  public showPreviews() {
    return this.props.previewImages?.map((image) => (
      <Img
        key={image.key}
        src={image.previewImageUrl}
        alt={`${this.props.title} - ${this.props.description}`}
      />
    ));
  }

  render() {
    // let downloadButtonIcon = <FontAwesomeIcon icon={faDownload} />
    // let fileName = this.props.title + this.props.fileExtension;
    let className = 'component file-component selectable';
    if (this.props.selected) {
      className += ' selected';
    }

    // Was causing re-render of image

    // let Comp = ({ onClick }: any) => (
    //     <div
    //         onClick={onClick}
    //         className={className}
    //         style={{
    //             ...backgroundStyle(this.context.styles, ColorType.light),
    //             ...rounded(),
    //             ...shadow(this.context.styles),
    //             background: this.props.darkBg ? "var(--heading-dark)" : "",
    //             color: this.props.darkBg ? "var(--heading-light)" : "",
    //         }}
    //     >
    //         <div className="item-image-container">
    //             <img
    //                 id={this.props.file.id}
    //                 src={this.props.file.url}
    //                 alt={this.props.description}
    //             />
    //         </div>

    //         {this.props.description ? (
    //             <div
    //                 dangerouslySetInnerHTML={{
    //                     __html: this.props.description,
    //                 }}
    //             />
    //         ) : (
    //             <p>{this.props.title}</p>
    //         )}
    //         <CheckBox
    //             show={this.props.showCheckbox || false}
    //             checked={this.props.selected || false}
    //             dark={this.props.darkBg}
    //         />
    //         {/*
    // <div className="item-footer">
    //     <FileIcon name={this.props.fileExtension} />

    //     <DownloadButtonWithProgress fileName={fileName } link={this.props.filePath} icon={downloadButtonIcon} className="download-button" />
    // </div> */}
    //     </div>
    // );

    const createLightbox = (src: string) => {
      let wrapper = document.createElement('div');
      let lightbox = document.createElement('div');
      let bottomUi = document.createElement('div');
      let resetBtn = document.createElement('button');
      let closeBtn = document.createElement('button');
      let img = document.createElement('img');
      closeBtn.classList.add('lightbox-close-btn');
      resetBtn.classList.add('lightbox-reset-btn');
      bottomUi.classList.add('lightbox__bottom-ui');
      wrapper.classList.add('lightbox-wrapper');
      lightbox.classList.add('lightbox');
      img.classList.add('lightbox__img');
      img.src = src;
      closeBtn.innerText = 'Close';
      resetBtn.innerText = 'Reset';
      const remove = () => {
        if (document.body.contains(wrapper)) {
          document.body.removeChild(wrapper);
          document.body.classList.remove('noscroll');
        }
      };
      wrapper.addEventListener('click', (e) => {
        if (e.target === wrapper) {
          remove();
        }
        // remove();
      });
      closeBtn.addEventListener('click', (e) => {
        remove();
      });
      lightbox.appendChild(img);
      wrapper.appendChild(lightbox);
      bottomUi.appendChild(closeBtn);
      bottomUi.appendChild(resetBtn);
      wrapper.appendChild(bottomUi);
      document.body.appendChild(wrapper);
      document.body.classList.add('noscroll');
      document.body.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          remove();
        }
      });
      // wrapper.addEventListener(
      //   'wheel',
      //   function (e) {
      //     let currentScale = lightbox.style.transform.match(/scale\((.*)\)/);
      //     let currentScaleVal = 1;
      //     if (Array.isArray(currentScale)) {
      //       currentScaleVal = parseInt(currentScale[1]);
      //     }
      //     let scale = (e.deltaY * -1) / 100 + currentScaleVal;
      //     console.log(currentScale);
      //     lightbox.style.transform = `scale(${scale})`;
      //   },
      //   false
      // );
      let mouseX = 0;
      let mouseY = 0;
      let mouseTX = 0;
      let mouseTY = 0;
      let panning = false;

      const ts = {
        scale: 1,
        rotate: 0,
        translate: {
          x: 0,
          y: 0,
        },
      };

      let zoomable = lightbox;
      zoomable.onwheel = function (event: any) {
        resetBtn.classList.add('visible');
        event.preventDefault();
        //need more handling  to avoid fast scrolls
        var func = zoomable.onwheel;
        zoomable.onwheel = null;

        let rec = zoomable.getBoundingClientRect();
        let x = (event.clientX - rec.x) / ts.scale;
        let y = (event.clientY - rec.y) / ts.scale;

        let delta = event.wheelDelta ? event.wheelDelta : -event.deltaY;
        ts.scale = delta > 0 ? ts.scale + 0.2 : ts.scale - 0.2;

        //let m = (ts.scale - 1) / 2;
        let m = delta > 0 ? 0.1 : -0.1;
        ts.translate.x += -x * m * 2 + zoomable.offsetWidth * m;
        ts.translate.y += -y * m * 2 + zoomable.offsetHeight * m;

        setTransform();
        zoomable.onwheel = func;
      };

      zoomable.onmousedown = function (event) {
        event.preventDefault();
        panning = true;
        zoomable.style.cursor = 'grabbing';
        mouseX = event.clientX;
        mouseY = event.clientY;
        mouseTX = ts.translate.x;
        mouseTY = ts.translate.y;
      };

      zoomable.onmouseup = function (event) {
        panning = false;
        zoomable.style.cursor = 'grab';
      };

      zoomable.onmousemove = function (event) {
        event.preventDefault();
        // let rec = zoomable.getBoundingClientRect();

        const x = event.clientX;
        const y = event.clientY;
        // let pointX = x - startX;
        // let pointY = y - startY;
        if (panning) {
          resetBtn.classList.add('visible');
        }
        if (!panning) {
          return;
        }
        ts.translate.x = mouseTX + (x - mouseX);
        ts.translate.y = mouseTY + (y - mouseY);
        setTransform();
      };

      function setTransform() {
        const steps = `translate(${ts.translate.x}px,${ts.translate.y}px) scale(${ts.scale}) translate3d(0,0,0)`;
        //console.log(steps);
        zoomable.style.transform = steps;
      }
      function reset() {
        resetBtn.classList.remove('visible');
        ts.scale = 1;
        ts.translate = {
          x: 0,
          y: 0,
        };
        zoomable.style.transform = 'none';
      }
      resetBtn.addEventListener('click', reset);
      setTransform();
    };

    return (
      <>
        <div style={{ position: 'relative' }}>
          {this.props.file && (
            <div
              className='img-zoom-icon'
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // this.props.file.id
                // this.props.file.url
                // this.props.description
                createLightbox(this.props.file.url);
              }}
              onMouseOver={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}>
              <ImZoomIn />
            </div>
          )}
          <div
            onClick={() => {
              !this.props.disableDownload && this.props.onClick(this.props.id);
            }}
            className={`${className}`}
            style={{
              ...backgroundStyle(this.context.styles, ColorType.light),
              ...rounded(),
              ...shadow(this.context.styles),
              color: this.props.darkBg ? 'var(--heading-light)' : '',
            }}>
            <div
              className={`transparent-bg ${
                this.props.darkBg ? 'transparent-bg--active' : ''
              }`}
              style={{
                backgroundImage: this.props.darkBg
                  ? `url(${
                      process.env.PUBLIC_URL + '/transparent-pattern.jpg'
                    }) `
                  : '',
              }}
            />
            <div className='item-image-container'>
              {this.props.file && (
                <Img
                  id={this.props.file.id}
                  src={this.props.file.url}
                  alt={this.props.description}
                />
              )}
              {/*                 
                  <div className="item-footer">
                      <FileIcon name={this.props.fileExtension} />
          
                      <DownloadButtonWithProgress fileName={fileName } link={this.props.filePath} icon={downloadButtonIcon} className="download-button" />
                  </div> */}
            </div>
          </div>
        </div>
        {!this.props.hideTitle &&
          (this.props.description ? (
            <div
              className='item-image-text'
              dangerouslySetInnerHTML={{
                __html: this.props.description,
              }}
            />
          ) : (
            <>
              <p>{this.props.title}</p>
            </>
          ))}
      </>
      // <Comp
      //     onClick={() =>
      //         !this.props.disableDownload &&
      //         this.props.onClick(this.props.id)
      //     }
      // />
    );
  }
}

export default FileComponent;
